import React, { FC, useId } from 'react';
import Link from 'next/link';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import styles from './FormAgreements.module.scss';
import classNames from 'classnames';

interface IFormAgreements {
  colorScheme?: 'dark' | 'grey' | 'light';
  register: UseFormRegister<any>;
  errors: FieldErrors<{ AGREEMENT: boolean; SUBSCRIBE: boolean }>;
  showSubscribe?: boolean;
}

const FormAgreements: FC<IFormAgreements> = ({
  colorScheme = 'light',
  errors,
  register,
  showSubscribe = false,
}) => {
  const id = useId();

  return (
    <div
      className={classNames(styles['form-agreements'], styles[`form-agreements--${colorScheme}`])}>
      <div className={styles['form-agreements__wrapper']}>
        <div className={styles['form-agreements__input-wrapper']}>
          <input
            type="checkbox"
            id={`${id}-agreement`}
            className={classNames(styles.checkbox, {
              [styles['input--error']]: errors.AGREEMENT,
            })}
            aria-label="Agreement"
            {...register('AGREEMENT', { required: true })}
          />
          <label htmlFor={`${id}-agreement`}>
            {showSubscribe ? (
              <>
                I agree to the <Link href="/help-center/terms-and-conditions/">Terms</Link> &{' '}
                <Link href="/help-center/privacy-policy/">Privacy Policy</Link>
              </>
            ) : (
              <>
                I want to receive exclusive content from Noord: insider guides and personalized tips
                for my store.
              </>
            )}
          </label>
        </div>

        {errors.AGREEMENT && <p className={styles.error}>{errors.AGREEMENT.message}</p>}
      </div>

      {showSubscribe && (
        <div className={styles['form-agreements__wrapper']}>
          <div className={styles['form-agreements__input-wrapper']}>
            <input
              type="checkbox"
              id={`${id}-subscribe`}
              className={classNames(styles.checkbox, {
                [styles['input--error']]: errors.SUBSCRIBE,
              })}
              aria-label="Agreement to receive emails from Noord"
              {...register('SUBSCRIBE')}
            />
            <label htmlFor={`${id}-subscribe`}>
              I want to receive exclusive content from Noord: insider guides and personalized tips
              for my store.
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormAgreements;
